import { ApplicationModules } from "../constants/modules";

export const getApplicationModules = () => {
  return [
    { value: "", label: "All Modules" },
    ...Object.values(ApplicationModules).map((module) => ({
      value: module,
      label: module,
    })),
  ];
};
